<template>
    <div id="task">
        <comheader></comheader>
        <div class="rf ks_right" id="rmodel">
            <comtop></comtop>
            <el-main>
                <div class="com_topaside">
                    <span>培训<b>></b></span>
                    <span>考试管理<b>></b></span>
                    <span>试卷管理<b></b></span>
                </div>
                <div class="com_typography">
                    <el-input placeholder="请输入内容" v-model="input" class="com_search lf" @change="searchtxt"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
                    <el-button type="primary" class="add_exam" icon="el-icon-plus" @click="hrefto">新建试卷</el-button>
                    <el-checkbox v-model="checked" class="rf com_checked" @change="chageMe">只看我创建的</el-checkbox>   
                     <el-cascader v-model="cascaderVal" ref="cascader" :options="options" class="rf cascaderV" :props="{ value: 'name',label:'name',children:'son' }"  :show-all-levels="false" @change="cascaderOp" clearable ></el-cascader>
                </div>
            </el-main>
            <el-main class="exam_wrap">
                <el-table :data="taskList" border style="width: 100%" class="exam_table exam_task"
                ref="multipleTable"
                >
                <el-table-column
                    v-for="info in tHeadr" :key="info.key"     
                    :property="info.key"
                    :label="info.label"
                    :width="info.width"
                   @click="handleClick(scope)"
                >
                <template slot-scope="scope">
                    {{scope.row[scope.column.property]}}  <!-- 渲染对应表格里面的内容 -->
                </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope" class="exam_btn">
                        <el-button @click="handleClick(scope)" type="text" size="large">编辑</el-button>
                        <el-button type="text" size="large" @click="delexam(scope.$index,scope.row.p_id)" class="exam_delbtn" >删除</el-button>
             
                    </template>
                </el-table-column>
                </el-table>
                <page :count="count" :Page.sync='page' @pagenation='pagetion' v-if="changeme"></page>
                <page :count="acount" :Page.sync='apage' @pagenation='apagetion' v-else></page>
            </el-main>
        </div>

    </div>
</template>

<script>
import comheader from '../Common/comheader'
import comtop from '../Common/comtop'
import page from '../Common/page'
import { checkindex } from '@/https/index'

 export default{
    name:'task',
    data(){
        return{
            input:'',
            checked:false,
            taskList:[],
            s_time:'',
            apage:1,
            apage:0,
            id:'',
            radio:'1',
            changeme:true,
            cascaderVal:'',
            limit:10, //一页几条数据
            options:[],
            count:0, //数据总计
            bmid:0,
            page:1, //当前页数
            pickerOptionsEnd: {},
            e_time:'',
            inGlist:[],
            tHeadr: [
                {
                    label: '试卷名称',
                    key: 'p_name',
                    width:'700'
                },
                {
                    label: '分类',
                    key: 'name',
                    width:'124'
                },
                {
                    label: '题目数',
                    key: 'p_questions',
                    width:'106 '
                },
                {
                    label: '总分',
                    key: 'p_scores',
                    width:'106'
                },
                {
                    label:'及格分',
                    key:'p_pass',
                    width:'106'
                },
                {
                    label:'创建时间',
                    key:'p_time',
                    width:'179'
                },
                {
                    label:'创建人',
                    key:'p_creatname',
                    width:'109'
                }
            ],
        }
    },
    components:{
        comheader,
        comtop,
        page    
    },
    methods:{
        hrefto(){
             let data = {
                'service':'Index.Check_Auth',
                'user_id':localStorage.getItem('userid'),
                'auth_root':'Exampaper.Paperadd'
                }
                checkindex(this.HOME,data).then(res=>{
                if(res.data.data.code=='405'){
                    this.alertView.failView(res.data.data.msg)
                    return false
                }
                this.$router.push({ path:'/addpaper'})
            })
        },
        delexam(i,id){
            console.log(i)
            console.log(id)
            const h = this.$createElement;
            var data={
                service:'Exampaper.Paperdel',
                id:id,
                userid:localStorage.getItem('userid')
            }
            this.$msgbox({
                title: '消息',
                message: h('p', null, [
                h('span', null, '是否确定删除')
                ]),
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton:true,
                lockScroll:false,
                showClose:false,
                customClass:'delBtn',
            }).then(action => {
                 this.$axios.post(this.HOME,this.$qs.stringify(data))
                    .then(res=>{
                        if(res.data.data.code==0){
                        this.taskList.splice(i,1)
                        this.alertView.successView(res.data.data.msg)
                        }
                        
                        else if(res.data.data.code==2)
                        {
                            this.alertView.failView(res.data.data.msg)
                        }
                        else{
                        this.alertView.failView(res.data.data.msg)
                        }
                })
            });
        },
      
        handleClick(id){
            let data = {
                'service':'Index.Check_Auth',
                'user_id':localStorage.getItem('userid'),
                'auth_root':'Exampaper.Paperadd'
                }
                checkindex(this.HOME,data).then(res=>{
                if(res.data.data.code=='405'){
                    this.alertView.failView(res.data.data.msg)
                    return false
                }
                var tid= id.row.p_id
                this.$router.push({ path:'/addpaper',query:{id:tid}})
            })
        },
        searchtxt(){
        var list =[]
        this.checked=''
        var that = this
        new Promise(function(resolve, reject){
        that.comview.search(that.HOME,{service:'Exampaper.Paperlist',where:that.input},function(res,Message){
         resolve(res,Message)
        })}).then(function(res,Message){
            if(res.data.data.code==0){
                 for(let i=0 ;i <res.data.data.info.list.length;i++){
                    list.push(res.data.data.info.list[i])
                    }
            that.count= parseInt(res.data.data.info.count)
            }
            else{
             that.alertView.failView('没有搜索到该试题')
            that.count= 1
            }
            that.taskList=list
            console.log(that.taskList)
        })
      },
      apagetion(limit,page){
        var List =[]
        var count =0
        this.cascaderVal=''
        this.input=''
        var data ={
              service:'Exampaper.My_Paper',
              userid:localStorage.getItem('userid'),
              limit:limit,
              page:page
                } 
                 this.$axios.post(this.HOME,this.$qs.stringify(data))
                    .then(res=>{
                        if(res.data.data.code==0){
                        this.count=parseInt(res.data.data.count)
                        for(let i=0 ;i <res.data.data.info.length;i++){
                            List.push(res.data.data.info[i])
                        }
                        }
                        console.log(List)
                        this.taskList=List
                    })
                        .catch(function (error) { // 请求失败处理
                        console.log(error)
                }); 
        },
    pagetion(limit,page){
        var data={service:'Exampaper.Paperlist',limit:limit,page:page,where:this.input}
        var List=[]
        var url =this.HOME
      this.$axios.post(url,this.$qs.stringify(data))
          .then(res=>{
               this.changeme=true
            if(res.data.data.code==0){
                
              this.count=parseInt(res.data.data.info.count)
              for(let i=0 ;i <res.data.data.info.list.length;i++){
                List.push(res.data.data.info.list[i])
              }
              this.taskList=List
            }
            
          })
            .catch(function (error) { // 请求失败处理
              console.log(error)
          });  
      },
      chageMe(e){
        var List =[]
        var count =0
        this.cascaderVal=''
        this.input=''
        if(e==true){
        this.changeme=false
        var data ={
              service:'Exampaper.My_Paper',
              userid:localStorage.getItem('userid')
                } 
                 this.$axios.post(this.HOME,this.$qs.stringify(data))
                    .then(res=>{
                        if(res.data.data.code==0){
                        this.acount=parseInt(res.data.data.count)
                        for(let i=0 ;i <res.data.data.info.length;i++){
                            List.push(res.data.data.info[i])
                        }
                        }
                        console.log(List)
                        this.taskList=List
                    })
                        .catch(function (error) { // 请求失败处理
                        console.log(error)
                }); 
        }
        else{
          this.changeme=true
          this.page=1
          this.pagetion(this.limit,this.page)
        }
      },
    cascaderOp(){
         let val = this.$refs['cascader'].getCheckedNodes();
        this.checked=''
        this.input=''
        var List=[]
         if(this.cascaderVal!=''){
             this.changeme=true
            let id = val[0].data.c_id
            var data ={
              service:'Exampaper.Paperlist',
              cate:id
                } 
                 this.$axios.post(this.HOME,this.$qs.stringify(data))
                    .then(res=>{
                        if(res.data.data.code==0){
                        this.count=parseInt(res.data.data.info.count)
                        for(let i=0 ;i <res.data.data.info.list.length;i++){
                            List.push(res.data.data.info.list[i])
                        }
                        }
                        else{
                            this.count=0
                        }
                        this.taskList=List
                    })
                        .catch(function (error) { // 请求失败处理
                        console.log(error)
                }); 
            }
             else{
                 this.pagetion(this.limit,this.page)
            }
        }
    
    },
    mounted(){
        this.pagetion(this.limit,this.page)
        var data =[];
        this.$axios.post(this.HOME,this.$qs.stringify({'service':'Cate.Cateinfo','userid':localStorage.getItem('userid')}))
        .then(res=>{
            if(res.data.data.code==405){
                this.alertView.failView(res.data.data.msg)
                this.$router.go(-1)
                return false
            }
            for(var i=0;i<res.data.data.length;i++){
                data.push(res.data.data[i])
            }
            this.options=data
            console.log(this.options)
        })
    }
 }
</script>
<style>
    @import "../../assets/css/task.css";
</style>


// WEBPACK FOOTER //
// src/components/test/test.vue